import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=2ee3300c&scoped=true&"
import script from "./PermissionsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsList.vue?vue&type=style&index=0&id=2ee3300c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3300c",
  null
  
)

export default component.exports